/*
  Grid Swatch Lite — Kitch speed fix
  ----------------------------------
  The stock Pipeline theme pre-renders a full <product-grid-item-variant>
  block (image, srcset, add-to-cart form) for EVERY colour swatch on every
  product card, which made collection HTML huge (3.4MB on /collections/samples).

  snippets/product-grid-item.liquid now renders only the visible variant
  block. This script restores the swatch behaviour: clicking a swatch swaps
  the visible card's image, links, and add-to-cart variant id in place.

  If a pre-rendered block for the target variant exists (unchanged sections),
  this script does nothing and lets the theme's own JS handle it.
*/
(function () {
  'use strict';

  var WIDTHS = [180, 360, 540, 720, 900];

  function urlAtWidth(src, w) {
    if (/([?&])width=\d+/.test(src)) {
      return src.replace(/([?&])width=\d+/, '$1width=' + w);
    }
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function buildSrcset(src) {
    if (!src) return null;
    return WIDTHS.map(function (w) {
      return urlAtWidth(src, w) + ' ' + w + 'w';
    }).join(', ');
  }

  function onSwatchClick(e) {
    var label = e.target.closest ? e.target.closest('.swatch__label') : null;
    if (!label) return;

    var card = label.closest('product-grid-item');
    if (!card) return;

    var targetId = label.getAttribute('data-grid-item-variant');
    if (!targetId) return;

    // Pre-rendered block still exists? Let the theme's own JS handle the swap.
    if (card.querySelector('product-grid-item-variant[data-grid-item-variant="' + targetId + '"]')) {
      return;
    }

    // Sold-out colours: fall through to normal navigation to the product page.
    var radio = label.closest('radio-swatch');
    if (radio && radio.classList.contains('sold-out')) return;

    e.preventDefault();
    e.stopPropagation();

    var block = card.querySelector('product-grid-item-variant:not([hidden])') ||
                card.querySelector('product-grid-item-variant');
    if (!block) return;

    // 1. Swap the visible image.
    var imgSrc = label.getAttribute('data-swatch-image');
    // Only swap when the attribute is a real URL (image_url output), not a bare file path.
    if (imgSrc && /^(https?:)?\/\//.test(imgSrc)) {
      var wrapper = block.querySelector('[data-grid-current-image]') ||
                    block.querySelector('product-grid-item-image');
      var img = wrapper ? wrapper.querySelector('img') : block.querySelector('img');
      if (img) {
        var srcset = buildSrcset(imgSrc);
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', urlAtWidth(imgSrc, 720));
      }
    }

    // 2. Point the card's links at the selected variant.
    var href = label.getAttribute('href');
    if (href) {
      block.querySelectorAll('a[data-grid-link]').forEach(function (a) {
        a.setAttribute('href', href);
      });
      card.querySelectorAll('.product__grid__info a[data-grid-link]').forEach(function (a) {
        a.setAttribute('href', href);
      });
    }

    // 3. Make instant-add add the selected variant to cart.
    block.querySelectorAll('form input[name="id"]').forEach(function (inp) {
      inp.value = targetId;
    });
    block.setAttribute('data-grid-item-variant', targetId);

    // 4. Selected state on the swatch strip.
    card.querySelectorAll('.swatch__label[aria-selected]').forEach(function (a) {
      a.removeAttribute('aria-selected');
    });
    label.setAttribute('aria-selected', 'true');
  }

  // Capture phase so we run before the theme's own swatch handler.
  document.addEventListener('click', onSwatchClick, true);
})();
